import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { detectWebDeviceType } from "../../../utils";
import { Badge } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { addProducts } from "../../../Redux/Action/productsAction";
import { toast } from "react-toastify";



function PackageItems({ onClose, packageItems,product, isAdd,changeProduct }) {
  const { t, i18n } = useTranslation();
    const deviceType = detectWebDeviceType();
  const dispatch = useDispatch();
  const localProducts = useSelector((state) => state.products.products);
  const returnProducts = useSelector((state) => state.returnProductReducer.products);
// console.log('localProducts==>',localProducts);
// console.log('packageItems==>',packageItems);

  const productArray = Object.values(localProducts);
  const returnArray = Object.values(returnProducts || []).map((product) => ({
    ...product,
    isReturn: true,
  }));
  const allProducts = [...productArray, ...returnArray];
  
// console.log(allProducts);
console.log('isAdd',product);

const ReplaceItem = (item) => {
  // const productArray = Object.values(localProducts);
  // const returnArray = Object.values(returnProducts || []).map((p) => ({
  //   ...p,
  //   isReturn: true,
  // }));

  // const allProducts = [...productArray, ...returnArray];

    const isAlreadyAdded = allProducts.some(
    (p) => p.pack_id && item.pack_id && p.pack_id === item.pack_id
  );

  if (isAlreadyAdded) {
    toast.error(t("Pack already added"));
    return;
  }

  const match = allProducts.find(
    (p) =>
      p.prod_id === product.prod_id &&
      (product.pack_id ? p.pack_id === product.pack_id : !p.pack_id)
  );
console.log('match',match);

  if (!match) {
    console.warn("Product not found to replace.");
    return;
  }

  const updatedProducts = [...productArray,...returnArray];

  const existingIndex = updatedProducts.findIndex(
    (p) =>
      p.prod_id === product.prod_id &&
      (product.pack_id ? p.pack_id === product.pack_id : !p.pack_id)
  );

  if (existingIndex !== -1) {
    updatedProducts[existingIndex] = {
      ...updatedProducts[existingIndex],
      name: item.product_name,
    pack_price: item.pack_price,
      sale_price: item.pack_price,
      pack_id: item.pack_id,
      pack_qty: item.pack_qty,
      barcode: item.secondary_barcode ? item.secondary_barcode : product?.barcode,
    };
  } else {
    const newProduct = {
      ...item,
      prod_id: item.product_id,
    pack_price: item.pack_price,
      name: item.product_name,
      sale_price: item.pack_price,
      pack_id: item.pack_id,
      pack_qty: item.pack_qty,
      barcode: item.secondary_barcode ? item.secondary_barcode : product?.barcode,
    };
    updatedProducts.push(newProduct);
  }

  dispatch(addProducts(updatedProducts));
  changeProduct()
  onClose();
};



const AddNewPackage = (item) => {
  const productArray = Object.values(localProducts);
  const returnArray = Object.values(returnProducts || []).map((product) => ({
    ...product,
    isReturn: true,
  }));

  const allProducts = [...productArray, ...returnArray];
  const match = allProducts.find((prod) => prod.prod_id === item.product_id);

  if (!match) {
    console.warn("Product not found in productArray or returnArray.");
    return;
  }

  const updatedProducts = [...productArray];

  // Check if a product with the same pack_id already exists
  const existingIndex = updatedProducts.findIndex(
    (p) => p.pack_id === item.pack_id
  );

  if (existingIndex !== -1) {
    // Increase quantity by 1
    updatedProducts[existingIndex].quantity += 1;
  } else {
    // Add new product with initial quantity
    const newProduct = {
      ...match,
      name: item.product_name,
      sale_price: item.pack_price,
      pack_id: item.pack_id,
      pack_qty: item.pack_qty,
    };
    updatedProducts.push(newProduct);
  }

  dispatch(addProducts(updatedProducts));
  changeProduct();
  onClose();
};



  return (
    <>
      <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50 backdrop-blur-md drop-shadow-sm">
        <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40"></div>
        <section
          className={`flex flex-col font-semibold leading-6 bg-white rounded-[25px] text-zinc-800 z-40 ${
            deviceType === "tablet" ? "px-12 pt-8 pb-12" : "px-12 pt-8 pb-12"
          } ${deviceType === "tablet" ? "fixed left-20" : "relative"} max-md:px-5 text-lg`}
          style={{
            width: deviceType === "tablet" ? "700px" : "800px",
          }}
        >
          <header className="flex gap-5 text-3xl max-md:flex-wrap max-md:max-w-full mb-2">
            <h1
              className={`my-auto ${
                deviceType === "tablet" ? "flex-auto text-xl" : "flex-auto"
              }`}
            >
              {isAdd ? t("Add New Pack Items"):t("Replace Pack Items")}
            </h1>
            <button
              type="button"
              onClick={onClose}
              className="text-zinc-800 absolute top-5 right-5 bg-transparent"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </header>

         <main className="mt-6">
  <div className="flex flex-wrap gap-4">
    {packageItems?.map((item, index) => {
      const isDisabled = item.pack_id === product.pack_id;

      return (
        <div
          key={index}
          onClick={() => {
            if (!isDisabled) {
              isAdd ? AddNewPackage(item) : ReplaceItem(item);
            }
          }}
          className={`w-[160px] border rounded-lg p-3 shadow-sm cursor-pointer transition-opacity duration-200 ${
            isDisabled
              ? "border-gray-300 bg-gray-100 text-gray-400 cursor-not-allowed opacity-60"
              : "border-gray-200 text-gray-800 hover:shadow-md"
          }`}
        >
          <div className="flex flex-col justify-center items-center rounded-md">
            <Badge
              style={{
    backgroundColor: "#065f46",
    color: "white",
    alignSelf: "flex-end",
    fontWeight: "600",
    width: 50,
    height: 50,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: -3,
    marginRight: -3,
    marginBottom: 3,
    borderRadius: 25, // half of width/height for a circle
    zIndex: 10,
  }}
            >
               x{item?.pack_qty}
            </Badge>

            <img
              loading="lazy"
              src={product.image_url}
              className="h-28 w-auto object-contain"
              alt={product.name}
            />
          </div>
          <div className="text-sm font-semibold mt-2 break-words whitespace-normal overflow-hidden">
            {item.product_name}
          </div>
          <div className="mt-1 text-sm font-bold mb-0">
            EGP {item.pack_price?.toFixed(2)}
          </div>
        </div>
      );
    })}
  </div>
</main>

        </section>
      </div>
    </>
  );
}

export default PackageItems;
